// @flow

import styled from "styled-components";
import { Flex } from "@src/common";

const Shelf = styled(Flex)`
    min-height: calc(100vh - 60px);
    background-color: ${({ theme }) => theme.colors.white};
`;

export default Shelf;



// WEBPACK FOOTER //
// ./src/containers/Assessment/Sidebar/components/Shelf.jsx